import React from 'react'
import { Card, CardBody, Heading, Text, Button } from '@pancakeswap-libs/uikit'
import BigNumber from 'bignumber.js/bignumber'
import styled from 'styled-components'
import { getBalanceNumber } from 'utils/formatBalance'
import { useTotalSupply, useBurnedBalance } from 'hooks/useTokenBalance'
import useI18n from 'hooks/useI18n'
import { getCakeAddress } from 'utils/addressHelpers'
import CardValue from './CardValue'
import { useFarms, usePriceCakeBusd } from '../../../state/hooks'

const StyledCakeStats = styled(Card)`
  margin-left: auto;
  margin-right: auto;
  // background-image: url('/images/coin_bg_02.png');
  background-repeat: no-repeat;
  background-position: bottom right;
  min-height: 310px;
`

const Row = styled.div`
  align-items: center;
  display: flex;
  font-size: 14px;
  justify-content: space-between;
  margin-bottom: 20px;

  @media screen and (max-width: 539px) {
    display: block;
  }
`

const CakeStats = () => {
  const TranslateString = useI18n()
  const totalSupply = useTotalSupply()
  const burnedBalance = useBurnedBalance(getCakeAddress())
  const farms = useFarms();
  const eggPrice = usePriceCakeBusd();
  const circSupply = totalSupply ? new BigNumber(18279849749000000000000000000) : new BigNumber(0)
  const cakeSupply = getBalanceNumber(circSupply)
  const marketCap = eggPrice.times(circSupply);

  let eggPerBlock = 0;
  if(farms && farms[0] && farms[0].eggPerBlock){
    eggPerBlock = new BigNumber(farms[0].eggPerBlock).div(new BigNumber(10).pow(18)).toNumber();
  }

  return (
    <StyledCakeStats className="white_box stats_box">
      <CardBody>
        <Heading size="xl" mb="10px" className="dash_head_1" style={{ display:"flex", alignItems: "center", justifyContent: "space-between" }}>
          {TranslateString(534, 'panKUKU Stats')}
          <Button className="cap_btn">Capped</Button>
        </Heading>
        <Row className="stats_box_row">
          <Text style={{ fontWeight: 400, fontSize: "14px", color:"#626262" }}>{TranslateString(10005, 'Market Cap')}</Text>
          <CardValue fontSize="14px" value={getBalanceNumber(marketCap)} decimals={0} prefix="$" />
        </Row>
        <Row className="stats_box_row">
          <Text style={{ fontWeight: 400, fontSize: "14px", color:"#626262" }}>{TranslateString(536, 'Total Minted')}</Text>
          {totalSupply && <CardValue fontSize="14px" value={getBalanceNumber(totalSupply)} decimals={0} />}
        </Row>
        <Row className="stats_box_row">
          <Text style={{ fontWeight: 400, fontSize: "14px", color:"#626262" }}>{TranslateString(538, 'Total Burned')}</Text>
          <CardValue fontSize="14px" value={getBalanceNumber(burnedBalance)} decimals={0} />
        </Row>
        <Row className="stats_box_row">
          <Text style={{ fontWeight: 400, fontSize: "14px", color:"#626262" }}>{TranslateString(10004, 'Circulating Supply')}</Text>
          {cakeSupply && <CardValue fontSize="14px" value={cakeSupply} decimals={0} />}
        </Row>
        {/* <Row className="stats_box_row">
          <Text style={{ fontWeight: 400, fontSize: "14px", color:"#626262" }}>{TranslateString(540, 'New Pankuku/Block')}</Text>
          <Text bold fontSize="14px">{eggPerBlock}</Text>
        </Row> */}
      </CardBody>
    </StyledCakeStats>
  )
}

export default CakeStats
